<template>
  <div class="home_content_wrapper">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: "RentRequestsHome",
};
</script>
